import { GoldenDomeNotificationType } from "@redotech/redo-model/golden-dome-notifications";
import { createEnum } from "@redotech/zod/zod-enum";
import * as z from "zod/v4";

export const updateGoldenDomeNotification = {
  name: "updateGoldenDomeNotification" as const,
  input: z.object({
    id: z.string(),
    appIds: z.array(z.string()).optional(),
    title: z.string().optional(),
    customMessage: z.string().optional(),
    notificationType: createEnum(GoldenDomeNotificationType).optional(),
    includeAppInstallationRemoved: z.boolean().optional(),
    notificationsSent: z
      .array(
        z.object({
          timestamp: z.date(),
          teamId: z.string(),
          appId: z.string(),
        }),
      )
      .optional(),
  }),
  output: z.null(),
};
